import './FilteredActionList-e1dde781.css';

var classes = {"Container":"prc-FilteredActionList-Container-2A9NQ","FullScreenTextInput":"prc-FilteredActionList-FullScreenTextInput-rCAiq"};

export { classes as default };
